import { KanbanCor } from '@shared/services/models/vendas/kanban-cor.model';

/** Cor de uma etapa já resolvida para o tema vigente — o template não escolhe entre claro e dark. */
export interface PvCorVm {
    principal: string;
    fundo: string;
    conteudo: string;
}

export const COR_PADRAO: PvCorVm = { principal: '#6B7682', fundo: '#EEF0F2', conteudo: '#4B5563' };

/** Escolhe o trio de cores do tema vigente. O catálogo traz os dois; a tela usa um. */
export function resolverCor(idKanbanCor: number, cores: KanbanCor[], isDarkMode: boolean): PvCorVm {
    const cor = cores.find(c => c.idKanbanCor === idKanbanCor);

    if (!cor) return COR_PADRAO;

    return isDarkMode
        ? { principal: cor.corPrincipalDark, fundo: cor.corFundoDark, conteudo: cor.corConteudoDark }
        : { principal: cor.corPrincipal, fundo: cor.corFundo, conteudo: cor.corConteudo };
}
